module.exports = __webpack_public_path__ + "img/ball_7_transparent.76d883fe.png";